module.exports = __webpack_public_path__ + "img/stock7.fdf48902.png";